module.exports = __webpack_public_path__ + "img/weddings_19_V.411657a1.webp";